const userTypes = [
  {
    key: '1',
    userLevel: 'Company User',
    description:
      'This is the highest level of a user, below super admin. This user can see all divisions, locations, etc. in MEO.',
    accessRights: 'Can see all divisions, locations, etc.',
  },
  {
    key: '2',
    userLevel: 'Division User',
    description:
      'This user level is above the location user level in the hierarchy, and below the company user level. This user will be restricted to one or many divisions and can see all locations within those divisions.',
    accessRights:
      'Restricted to one or more divisions and locations within them.',
  },
  {
    key: '3',
    userLevel: 'Location User',
    description:
      'This user level is below the division user in the hierarchy. This user will be restricted to one or many locations.',
    accessRights: 'Restricted to one or more locations.',
  },
];

const generalPermissions = [
  {
    key: '1',
    permission: 'Active',
    description:
      'If set to yes, the user is active in MEO and can see things based on the other permissions that have been defined. If set to no, the user is inactive in MEO. This means that they can still login but can’t see anything. This should be the default position when a user is first added.',
  },
  {
    key: '2',
    permission: 'Admin',
    description:
      'Can add and delete users. Can assign/change permissions. Admin has to be a corporate level user. Can see and edit all sections in MEO.',
  },
  {
    key: '3',
    permission: 'Export',
    description:
      'If set to yes, this means the user can export excel files and the BCP PDF. If set to no, this means the user cannot export anything from MEO.',
  },
  {
    key: '4',
    permission: 'Financials',
    description:
      'If set to yes, this means the user can see financial figures in all sections in MEO. If set to no, this means the user cannot see financial figures in any section in MEO. This does not apply to replacement cost in the location, process area, and process data inputs section.',
  },
  {
    key: '5',
    permission: 'Edit',
    description:
      'If set to yes, this means the user can add / edit information in all sections that they have access to, based on their user other permissions. If set to no, this means the user is read only and cannot edit any sections.',
  },
  {
    key: '6',
    permission: 'Approver',
    description:
      'If set to yes, this person can finalize BCP strategies and approve them (this will matter more once we re-work the approvals flow for BCP strategies). If set to no, this person cannot finalize BCP strategies.',
  },
];

export { userTypes, generalPermissions };
